import { axiosPatch, axiosPost } from "../../../../../../packages/apiPackage/axiosRequest";
import ApiConstants from "../../../../../../utils/apiConstants"

async function UpdatePastExp({ setBtnLoading, btnLoading,
    profilePic, name, feedback, address, id }) {

    if (!btnLoading) {
        setBtnLoading(true);
        try {
            // console.log("section = ", section)
            await axiosPatch({
                endpoint: `${ApiConstants.UPDATE_PE_EXPERIENCE}/${id}`,
                jsonBody: JSON.stringify({
                    name: name,
                    feedback: feedback,
                    address: address,
                })
            })

            //upload pdf here...
            if (profilePic) {
                const formData = new FormData();
                formData.append('file', profilePic);

                let res = await axiosPost({
                    endpoint: `${ApiConstants.UPLOAD_PE_PIC}/${id}`,
                    formData: formData
                })
                console.log('File uploaded successfully! = ', res);
            }
            // console.log("response = ", response);
            setBtnLoading(false);
            return true;
        } catch (error) {
            console.log("error = ", error)
            setBtnLoading(false);
            if (!error?.response) {
                console.log("No server response.");
                // console.log("Login credit Expired.\nPlease Login Again!!!");
            } else if (error.response?.status === 404 || error.response?.status === 401) {
                console.log("Server Error !!! Try Logging in again.");
            } else {
                console.log("Login credit Expired.\nPlease Login Again!!!");
            }
            return false;
        }
    }
}

export default UpdatePastExp;